import Quill from 'quill';
export const fontSizeArr = [
  false,
  '10px',
  '11px',
  '12px',
  '14px',
  '16px',
  '18px',
  '20px',
  '24px',
  '30px',
  '36px',
];

const Parchment = Quill.import('parchment') as any;
const FontSizeStyle = new Parchment.StyleAttributor('size', 'font-size', {
  scope: Parchment.Scope.INLINE,
  whitelist: fontSizeArr,
});

Quill.register(FontSizeStyle, true);
